import React from 'react'

import HR from 'components/HR'
import TrustPilotWidget from 'components/TrustPilot/Widget'
import { MainContent } from 'styles/algolia'

import Header from '../components/Header'
import PaginationHitsPerPageLayout from './PaginationHitsPerPage'
import CollectionsList from '../components/collections/CollectionsList'
import { Layout } from '../components/styles'
import ViewType from '../components/Header/ViewType'

const AccountCollectionsLayout = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <>
      <Layout>
        <Header />
        <ViewType />
        <MainContent>
          <CollectionsList />
        </MainContent>
      </Layout>

      <HR />

      <PaginationHitsPerPageLayout />

      <TrustPilotWidget />

      <HR />
    </>
  )
}

export default AccountCollectionsLayout
